<template>
  <div>
    <empty-reminder v-show="records.length == 0 && !loading"></empty-reminder>

    <div>
      <div class="record" v-for="record in records">
        <p class="description">{{ getDescription(record.nickname, record.status) }}</p>
        <p class="time">{{ $t('time') }}{{ $t(':') }}{{ record.created_at | createFormatTime(record.created_at) }}</p>
      </div>
    </div>

    <spinner :show="loading" class="spinner-component"></spinner>
    <back-to-top></back-to-top>
    <load-more :current-page="currentPage" :total-page="totalPage"
               :loading="loading" @click.native="getFriendRecords"></load-more>
  </div>
</template>

<script>
  import {createFormatTime} from 'src/lib/filters'
  import locales from './lang'
  import EmptyReminder from '../EmptyReminder.vue'
  import Spinner from '../../Spinner.vue'
  import LoadMore from '../../loadMore/LoadMore.vue'
  import BackToTop from '../../backToTop/BackToTop.vue'

  export default {
    name: 'friend-records-m',
    components: {EmptyReminder, LoadMore, Spinner, BackToTop},
    props: ['initInvitationRecordsData'],
    data: function () {
      return {
        records: [],
        loading: false,
        totalPage: 1,
        currentPage: 0
      }
    },
    locales,
    watch: {
      initInvitationRecordsData() {
        this.records = this.initInvitationRecordsData.data
        this.totalPage = Math.ceil(this.initInvitationRecordsData.meta['total'] / this.initInvitationRecordsData.meta['per_page'])
        this.currentPage = this.initInvitationRecordsData.meta['current_page']
      }
    },
    methods: {
      getFriendRecords() {
        if (this.currentPage > this.totalPage) {
          return
        }
        this.loading = true
        this.currentPage++
        this.$http.get('api/invitation-records', {params: {'page': this.currentPage}}).then(response => {
          this.loading = false
          this.records = this.records.concat(response.data.data)
          this.totalPage = Math.ceil(response.data.meta['total'] / response.data.meta['per_page'])
        }, response => {
          this.loading = false
        })
      },
      getDescription(nickname, status) {
        if (status === 'registered') {
          return this.$t('user') + nickname + this.$t('register')
        } else {
          return this.$t('user') + nickname + this.$t('recharge')
        }
      }
    },
    filters: {createFormatTime}
  }
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
  @import "../../../assets/scss/variables";

  * {
    padding: 0;
    margin: 0;
  }

  .record {
    padding: .16rem 0;
    &:not(:last-child) {
      border-bottom: 1px solid #EFEFEF;
    }
  }

  p {
    font-size: .12rem;
    color: #666;
    letter-spacing: 0;
    line-height: .18rem;

    &.description {
      font-size: .14rem;
      line-height: .2rem;
      color: #333;
      margin-bottom: .12rem;
    }
  }

  .spinner-component {
    margin: 0 auto .1rem auto;
  }
</style>



// WEBPACK FOOTER //
// FriendRecordsM.vue?3adea356